var _defs, _path, _path2, _path3, _text, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 132.98 23.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{font-size:20.28px;fill:#171044;font-family:FranklinGothic-Heavy, Franklin Gothic Heavy;font-weight:800;}.cls-5{fill:#121631;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 77.9,
    y1: 64.53,
    x2: -13.98,
    y2: 4.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71cddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4ac7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#49c1e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4298ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3b77b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#375ba3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#334998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2f3e90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e3b8e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 77.42,
    y1: 64.35,
    x2: -13.8,
    y2: 4.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 75.04,
    y1: 65.34,
    x2: -14.69,
    y2: 6.67,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,16.26c-2.48,1.74-6.2-2.18-8.82-4.76C16.67,7.93,13.53,7.18,12.27,7a.17.17,0,0,1-.15-.19.14.14,0,0,1,0-.06A8,8,0,0,1,27,8.82a.13.13,0,0,0,.09.11A4.75,4.75,0,0,1,29.92,12h0C30.06,12.58,30.76,15,29,16.26Z",
    transform: "translate(-5.2 -1.65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.09,15.87c.72.72,1.42,1.48,2.14,2.2a1.21,1.21,0,0,0,.83.33h7.23a.17.17,0,0,0,.18-.16.17.17,0,0,0-.11-.17c-2.15-.89-4-3.3-5.73-5.07a15,15,0,0,0-7.2-4.3h-.14a5.71,5.71,0,0,0-1-.13h-.16A4.9,4.9,0,0,0,5.86,11a.26.26,0,0,0,.09.37.21.21,0,0,0,.12,0C7.25,11.55,10.47,12.24,14.09,15.87Z",
    transform: "translate(-5.2 -1.65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.55,18.4H10.13A4.93,4.93,0,0,1,5.2,13.47V13.4a.26.26,0,0,1,.25-.27h.08a17.06,17.06,0,0,1,7.29,4.53S13.6,18.4,12.55,18.4Z",
    transform: "translate(-5.2 -1.65)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(30.29 16.9)"
  }, "Waterwell")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135,9.13a3.2,3.2,0,1,1,3.2-3.2h0A3.21,3.21,0,0,1,135,9.13Zm0-5.73a2.53,2.53,0,1,0,2.53,2.53h0A2.53,2.53,0,0,0,135,3.4Z",
    transform: "translate(-5.2 -1.65)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.5,6.25V7.58h-.65V4.31h1.22a1.3,1.3,0,0,1,.9.27.84.84,0,0,1,.31.71.68.68,0,0,1-.13.43.84.84,0,0,1-.38.29.67.67,0,0,1,.41.28.86.86,0,0,1,.13.49V7a1.41,1.41,0,0,0,0,.29.42.42,0,0,0,.13.21v.07h-.67a.41.41,0,0,1-.11-.24,1.61,1.61,0,0,1,0-.31V6.76a.48.48,0,0,0-.13-.38.54.54,0,0,0-.37-.13Zm0-.5h.56a.61.61,0,0,0,.4-.11.43.43,0,0,0,.14-.35.43.43,0,0,0-.14-.35.49.49,0,0,0-.39-.13h-.57Z",
    transform: "translate(-5.2 -1.65)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b3be3c94f5a2754e671f14bf96915cbe.svg";
export { ForwardRef as ReactComponent };